import React from 'react';
import './NewsLetter.css';

const NewsLetter = () => {
  return (
    <div className='newsletter'>
      <div className="newsletter-content">
        <h1>📩 Subscribe to Our Tech Insights</h1>
        <p>Get latest articles, tutorials, and updates delivered directly to your inbox.</p>
        <div className="newsletter-form">
          <input type="email" placeholder='Enter your email address' />
          <button>Subscribe</button>
        </div>
      </div>
    </div>
  );
}

export default NewsLetter;